module.exports = __webpack_public_path__ + "img/del.6885efb5.png";